import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import classnames from "classnames";

import { AddressBlock } from "@/components/Account/Profile/ProfileAddressBook/components/AddressBlock/addressBlock.component";
import { Divider } from "@/components/General/Divider/divider.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    addresses: Array<CloudCustomerAddress>;
    updateDefaultBilling: (address: CloudCustomerAddress) => Promise<void>;
    updateDefaultDelivery: (address: CloudCustomerAddress) => Promise<void>;
    canDelete: boolean;
    updateAddress: (address: CloudCustomerAddress) => Promise<void>;
};

const OtherAddresses = ({
    addresses,
    updateDefaultBilling,
    updateDefaultDelivery,
    canDelete,
    updateAddress
}: Props) => {
    const { t } = useGranite();

    return (
        <>
            {addresses.length > 0 && (
                <>
                    <Row className={classnames("mt-3")}>
                        <Col>
                            <h3>{t("address.title.others")}</h3>
                            <Divider />
                        </Col>
                    </Row>
                    <Row>
                        {addresses.map((address) => (
                            <Col
                                xs={12}
                                md={6}
                                key={address.id}
                                className={classnames("mt-3")}
                            >
                                <AddressBlock
                                    address={address}
                                    updateDefaultDelivery={
                                        updateDefaultDelivery
                                    }
                                    updateDefaultBilling={updateDefaultBilling}
                                    canDelete={canDelete}
                                    updateAddress={updateAddress}
                                />
                            </Col>
                        ))}
                    </Row>
                </>
            )}
        </>
    );
};

export default OtherAddresses;
